<div class="d-flex justify-content-center">
  <em *ngIf="enableEdit && isAccessible">
    <img class="me-2" src="assets/images/EDIT-ICON.svg" (click)="btnClickedHandler('mainEdit')" title="Edit Event" />
  </em>
  <em *ngIf="enableReport">
    <img class="me-2" src="assets/images/file-icon.svg" (click)="btnClickedHandler('generate-popUp')" title="Download Report"/>
  </em>
  <em *ngIf="enableReopenEvent && isAccessible">
    <img class="me-2" src="assets/images/box-open-solid.svg" (click)="btnClickedHandler('reopen')" title="Reopen" />
  </em>
  <em *ngIf="enablecloseEvent && isAccessible">
    <img
      src="assets/images/closeEvent.svg"
      (click)="btnClickedHandler('close-event')"
      title="Close Event"
    />
  </em>
  <em *ngIf="enableFinalEdit && isAccessible">
    <img class="me-2" src="assets/images/EDIT-ICON.svg" (click)="btnClickedHandler('childEdit')" />
  </em>
  <em *ngIf="enableimages">
    <img class="me-2 bright" src="assets/images/imageResol.svg" (click)="btnClickedHandler('imagePop')" />
  </em>
  <em *ngIf="rightArrow">
    <img class="me-2 bright handler" src="assets/images/caret-right-solid.svg" (click)="btnClickedHandler('openChild')" />
  </em>
</div>